import { Simdata5gorderService } from 'src/services/simdata5gorder.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const SIMDATA5GORDER_NEW_CARE_SUCCESS = 'SIMDATA5GORDER:NEW_CARE_SUCCESS'
export const SIMDATA5GORDER_LIST_SUCCESS = 'SIMDATA5GORDER:FIND_ALL_SUCCESS'
export const SIMDATA5GORDER_LIST_FAILD = 'SIMDATA5GORDER:FIND_ALL_FAILD'
export const SIMDATA5GORDER_COUNT_ASSIGN_SUCCESS = 'SIMDATA5GORDER:COUNT_ASSIGN_SUCCESS'
export const SIMDATA5GORDER_COUNT_ASSIGN_FAILD = 'SIMDATA5GORDER:COUNT_ASSIGN_FAILD'

export const SIMDATA5GORDER_CREATE_SUCCESS = 'SIMDATA5GORDER:CREATE_SUCCESS'
export const SIMDATA5GORDER_CREATE_FAILD = 'SIMDATA5GORDER:CREATE_FAILD'

export const SIMDATA5GORDER_IMPORT_SUCCESS = 'SIMDATA5GORDER:IMPORT_SUCCESS'
export const SIMDATA5GORDER_SAVE_SUCCESS = 'SIMDATA5GORDER:SAVE_SUCCESS'
export const SIMDATA5GORDER_SAVE_FAILD = 'SIMDATA5GORDER:SAVE_SUCCESS'

export const SIMDATA5GORDER_DEL_SUCCESS = 'SIMDATA5GORDER:DEL_SUCCESS'
export const SIMDATA5GORDER_DEL_FAILD = 'SIMDATA5GORDER:DEL_FAILD'

export const SIMDATA5GORDER_ONE_SUCCESS = 'SIMDATA5GORDER:FIND_ONE_SUCCESS'
export const SIMDATA5GORDER_ONE_FAILD = 'SIMDATA5GORDER:FIND_ONE_FAILD'

export const SIMDATA5GORDER_HISTORY_LIST_SUCCESS = 'SIMDATA5GORDER:HISTORY_FIND_ALL_SUCCESS'
export const SIMDATA5GORDER_HISTORY_LIST_FAILD = 'SIMDATA5GORDER:HISTORY_FIND_ALL_FAILD'

export const SIMDATA5GORDER_UPDATE_FILTER = 'SIMDATA5GORDER:SIMDATA5GORDER_UPDATE_FILTER'

export const SIMDATA5GORDER_LIST_EXPORT_SUCCESS = 'SIMDATA5GORDER:FIND_ALL_EXPORT_SUCCESS'
export const SIMDATA5GORDER_LIST_EXPORT_FAILD = 'SIMDATA5GORDER:FIND_ALL_EXPORT_FAILD'

export const SIMDATA5GORDER_SIMDATA5GORDER_SUCCESS = 'SIMDATA5GORDER:SIMDATA5GORDER_SUCCESS'
export const SIMDATA5GORDER_SIMDATA5GORDER_FAILD = 'SIMDATA5GORDER:SIMDATA5GORDER_FAILD'

export const SIMDATA5GORDER_UPDATE_HOMEPAGE_FILTER = 'SIMDATA5GORDER:SIMDATA5GORDER_UPDATE_HOMEPAGE_FILTER'

export const SIMDATA5GORDER_HOMEPAGE_LIST_SUCCESS = 'SIMDATA5GORDER:FIND_HOMEPAGE_LIST_SUCCESS'
export const SIMDATA5GORDER_HOMEPAGE_LIST_FAILD = 'SIMDATA5GORDER:FIND_HOMEPAGE_LIST_FAILD'

export const SIMDATA5GORDER_HOMEPAGE_ONE_SUCCESS = 'SIMDATA5GORDER:FIND_HOMEPAGE_ONE_SUCCESS'
export const SIMDATA5GORDER_HOMEPAGE_ONE_FAILD = 'SIMDATA5GORDER:FIND_HOMEPAGE_ONE_FAILD'

export const SIMDATA5GORDER_LIMIT_UPDATE_HOMEPAGE_FILTER = 'SIMDATA5GORDER:SIMDATA5GORDER_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const SIMDATA5GORDER_LIMIT_HOMEPAGE_LIST_SUCCESS = 'SIMDATA5GORDER:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const SIMDATA5GORDER_LIMIT_HOMEPAGE_LIST_FAILD = 'SIMDATA5GORDER:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const SIMDATA5GORDER_LIMIT_HOMEPAGE_ONE_SUCCESS = 'SIMDATA5GORDER:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const SIMDATA5GORDER_LIMIT_HOMEPAGE_ONE_FAILD = 'SIMDATA5GORDER:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const Simdata5gorderAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,
    sendSimdata5gorder,
}

function updateHomepageFilter(payload) {
    return { type: SIMDATA5GORDER_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { simdata5gorder } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageSimdata5gorderFilter } = simdata5gorder;
        const homepageSimdata5gorderPage = homepageSimdata5gorderFilter.homepageSimdata5gorderPage;
        const homepageSimdata5gorderLimit = homepageSimdata5gorderFilter.homepageSimdata5gorderLimit;

        return new Promise((resolve, reject) => {
            Simdata5gorderService.homepageList(homepageSimdata5gorderFilter).then((rs) => {
                if (!!homepageSimdata5gorderFilter && homepageSimdata5gorderFilter.homepageSimdata5gorderPage === 0) {
                    dispatch(success({
                        homepageSimdata5gorderItems: rs.data.values,
                        homepageSimdata5gorderTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = simdata5gorder.homepageSimdata5gorderItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageSimdata5gorderLimit * homepageSimdata5gorderPage; i < homepageSimdata5gorderLimit * homepageSimdata5gorderPage + homepageSimdata5gorderLimit; i++) {
                        if (typeof rsDataValues[i - homepageSimdata5gorderLimit * homepageSimdata5gorderPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageSimdata5gorderLimit * homepageSimdata5gorderPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageSimdata5gorderItems: uniqueItems,
                        homepageSimdata5gorderTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMDATA5GORDER_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: SIMDATA5GORDER_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { simdata5gorder } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageSimdata5gorderLimitFilter } = simdata5gorder;
        const homepageSimdata5gorderLimitPage = homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitPage;
        const homepageSimdata5gorderLimitLimit = homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitLimit;

        return new Promise((resolve, reject) => {
            Simdata5gorderService.homepageLimitList(homepageSimdata5gorderLimitFilter).then((rs) => {
                if (!!homepageSimdata5gorderLimitFilter && homepageSimdata5gorderLimitFilter.homepageSimdata5gorderLimitPage === 0) {
                    dispatch(success({
                        homepageSimdata5gorderLimitItems: rs.data.values,
                        homepageSimdata5gorderLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = simdata5gorder.homepageSimdata5gorderLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageSimdata5gorderLimitLimit * homepageSimdata5gorderLimitPage; i < homepageSimdata5gorderLimitLimit * homepageSimdata5gorderLimitPage + homepageSimdata5gorderLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageSimdata5gorderLimitLimit * homepageSimdata5gorderLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageSimdata5gorderLimitLimit * homepageSimdata5gorderLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageSimdata5gorderLimitItems: uniqueItems,
                        homepageSimdata5gorderLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMDATA5GORDER_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: SIMDATA5GORDER_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      Simdata5gorderService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: SIMDATA5GORDER_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { simdata5gorder } = getState()
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...simdata5gorder.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            Simdata5gorderService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: SIMDATA5GORDER_SAVE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            Simdata5gorderService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { simdata5gorder } = getState();

            const { filter } = simdata5gorder;

            // Perform your asynchronous operation (e.g., API call)
            Simdata5gorderService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: SIMDATA5GORDER_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { simdata5gorder } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = simdata5gorder;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            Simdata5gorderService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = simdata5gorder.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMDATA5GORDER_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: SIMDATA5GORDER_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            Simdata5gorderService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(Simdata5gorderAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: SIMDATA5GORDER_SAVE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_SAVE_FAILD, error } }
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(Simdata5gorderAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng số điện thoại!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(Simdata5gorderAction.list())
            if (typeof rs.msg !== 'undefined' && rs.msg) {
                alert(rs.msg)
            }
        }).catch((error) => {
            dispatch(failure(error));
            alert("Lỗi không xác định!")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(Simdata5gorderAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_DEL_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(Simdata5gorderAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { simdata5gorder } = getState()
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...simdata5gorder.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_HISTORY_LIST_FAILD, error } }
}

function sendSimdata5gorder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Simdata5gorderService.sendSimdata5gorder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5GORDER_SIMDATA5GORDER_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5GORDER_SIMDATA5GORDER_FAILD, error } }
}